export default __webpack_public_path__ + "static/media/nomina1.5cfbd85b.png";